import React from 'react';

export default ({colSpan})=>(
  <tr style={{backgroundColor: '#f4f3e8', color: '#b75454'}}><td colSpan={colSpan}>No data</td></tr>
)


// WEBPACK FOOTER //
// ./src/components/common/NoDataNode.js